"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeThousandSeparator = void 0;
const removeThousandSeparator = (amount) => {
    if (typeof amount === "number") {
        return amount.toString().replace(/,/g, "");
    }
    return amount.replace(/,/g, "");
};
exports.removeThousandSeparator = removeThousandSeparator;
